export default __webpack_public_path__ + "static/media/aleximage.511671c3.jpeg";